import React from 'react';
import {HorizontalBar} from 'react-chartjs-2';



const Bar = ({n_pos, n_neg}) => {
    const data = {
        labels: ['Positive', 'Negetive'],
        datasets: [
          {
            label: 'Count',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: [n_pos, n_neg, 0]
          }
        ]
      };
    return (
      <div>
        <center><h2>Number of Positive and Negetive Reviews</h2></center>
        <hr className="line"/>
        <HorizontalBar 
            height={80} 
            
            data={data} 
        />
      </div>
    );
  }

export default Bar;